import type { DataProxy } from '@apollo/client/core';
import type { RawLocation } from 'vue-router';
import type { Maybe, PublicPortfolioCurrentUser, Testimonial, TestimonialState } from '~/types/graphql';
import { sortByField } from '~/components/utils/sorting_func';
import { PublicPortfolioCurrentUserQuery } from '~/apollo/queries/PublicPortfolio/PublicPortfolioCurrentUser.query';
import { PUBLIC_PORTFOLIO_ROUTE_NAME } from '~/components/partials/public-portfolio/constants';
import { PUBLIC_PORTFOLIO_APPROVE_TESTIMONIAL_MODAL } from '~/constants';

type State = TestimonialState | 'archiving';
export const testimonialsByStates = (testimonials: Maybe<Testimonial[]>, states: State[]): Array<Testimonial> => {
  if (testimonials) {
    const list = states.length ? testimonials.filter((t: Testimonial) => states.includes(t.state)) : testimonials;

    return [...list].sort(sortByField('position'));
  } else {
    return [];
  }
};

export const updateTestimonial = (store: DataProxy, id: string, input: { state?: string; position?: string }): void => {
  const query = {
    query: PublicPortfolioCurrentUserQuery,
  };

  const data = store.readQuery<{ publicPortfolioCurrentUser: PublicPortfolioCurrentUser }>(query);

  if (data?.publicPortfolioCurrentUser) {
    const testimonials = data.publicPortfolioCurrentUser?.testimonials || [];

    const testimonial = testimonials.find((t: Testimonial) => t.id === id);
    if (testimonial) {
      Object.assign(testimonial, input);
    }
    data.publicPortfolioCurrentUser.testimonials = testimonials;

    store.writeQuery({ ...query, data });
  }
};

export const getTestimonialApprovalRoute = (slug: string, testimonialId: string): RawLocation => {
  return {
    name: PUBLIC_PORTFOLIO_ROUTE_NAME,
    params: { slug },
    query: {
      'testimonial-id': testimonialId,
      dynamic_modal: PUBLIC_PORTFOLIO_APPROVE_TESTIMONIAL_MODAL,
    },
  };
};
